import Module from 'epa-components-platform/src/lib/helper/js/Module';

export default class Scrollable extends Module {
  mask = {
    left: undefined,
    right: undefined
  }

  contentHasScrollListener = false;

  constructor(el) {
    super();

    this.el = el;
    
    this.content = this.el.querySelector('.scrollable-content');
    this.contentInner = this.content.children.item(0);
    
    this.maskWrapper = this.el.querySelector('.scrollable-mask');
    this.mask.left = this.maskWrapper.querySelector('.is-left');
    this.mask.right = this.maskWrapper.querySelector('.is-right');

    this.init();

    window.addEventListener('resize', this.init);
  }

  init = () => {
    if (this.isScrollable()) {
      this.maskWrapper.classList.remove('d-none');

      if (!this.contentHasScrollListener) {
        this.initScrollListener();
        this.contentHasScrollListener = true;
      }

    } else {
      this.maskWrapper.classList.add('d-none');
      this.disposeScrollListener();
      this.contentHasScrollListener = false;
    }
  }

  initScrollListener() {
    this.content.addEventListener('scroll', this.handleMasksOnScroll);
  }

  disposeScrollListener() {
    this.content.removeEventListener('scroll', this.handleMasksOnScroll);
  }

  handleMasksOnScroll = (event) => {
    const scroll = event.target.scrollLeft;

    if (scroll > 0) {
      this.mask.left.classList.remove('is-hidden');
    } else {
      this.mask.left.classList.add('is-hidden');
    }

    if (scroll + this.content.offsetWidth < this.contentInner.offsetWidth) {
      this.mask.right.classList.remove('is-hidden');
    } else {
      this.mask.right.classList.add('is-hidden');
    }
  }

  isScrollable() {
    const elWidth = this.el.offsetWidth;
    const contentWidth = this.contentInner.offsetWidth;

    return contentWidth > elWidth;
  }
}